import React from "react"
import AppCalendarEventsAction from "./Events";
import AppCalendarAlertsAction from "./Alerts";
import AppDetailsAction from './Details'

export default function AppCalendarCellActions({ date, showLocationData }) {

    return <>
        {!!showLocationData && <AppDetailsAction date={date} />}
        <AppCalendarEventsAction date={date} />
        <AppCalendarAlertsAction date={date} />
    </>
}